import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import Btn from '../button/btn/Btn';
import * as css from './ManagePromotion.css';
import {openWhatsApp} from '../../library/whatsApp';
import {getDomain} from '../../layout/eventMenu/formButtton/FormButtton';
import {logGoogleEvent} from '../../utils/analytics';

const MARKETING_WHATSAPP_PHONE = '972586842770';

function PromotionWhatsappButton({pmid, feature}: {pmid: number; feature: 'realtime' | 'publish'}) {
    const {t} = useTranslation('promotionMessage');
    const {title, domain, landingPageUrl, name, type} = useSelector((state: any) => state.event);

    const contactRep = () => {
        const eventLink = getDomain(domain, landingPageUrl, name, type);
        openWhatsApp(MARKETING_WHATSAPP_PHONE, t('whatsappContactMessage', {title, link: eventLink}));
        logGoogleEvent(`${feature}_promotion_whatsapp_contact_click`, pmid, `pmid-${pmid}`, {
            popup_name: 'promotionPopup',
            feature
        });
    };

    return (
        <Btn onClick={contactRep} className={'white'} disabled={false} dataCy="promotionWhatsappContact">
            <css.whatsappIcon />
            {t('contactRep')}
        </Btn>
    );
}

export default PromotionWhatsappButton;
